import axios from "axios";
import { apiUrl } from "../../config";

export const getCustomersByPhoneNumber = (phone_number) => {
    const params = {
        phone_number: phone_number
    };
    return axios.get(`${apiUrl}/customers/by-phone-number`, { params });
};